module.exports = __webpack_public_path__ + "img/poster_011.076cd26e.jpg";